export const environment = {
  production: true,
  hmr: false,
  CORE_URL: "https://core.ivolunteer.at",
  CONFIGURATOR_URL: "https://config-backend.ivolunteer.at",
  MODE: "iVolunteer" // 'iVolunteer' || 'flexprod' || 'all'
};